import React from 'react';
import type { IOverviewSectionProps } from './types';
import useLanguage from '@op/hooks/useLanguage';
import './index.scss'; 

export default function OverviewSection({ overview }: IOverviewSectionProps) {
  const {formatMessage } = useLanguage();
  return (
    <div className="dbo-event-detail-overview">
      <div className="dbo-event-detail-section__title">{formatMessage("Anomaly Overview")}</div>
      <div className="dbo-event-detail-overview__content">{overview}</div>
    </div>
  );
}
